export interface FallbackVerse {
  [reference: string]: {
    pt: string;
    'pt-PT': string;
    en: string;
    es: string;
    fr: string;
    de: string;
    it: string;
    zh: string;
    ja: string;
    ko: string;
    ar: string;
  };
}

export const BIBLE_FALLBACK_QUOTES: FallbackVerse = {
  'Proverbs 16:24': {
    pt: 'Palavras agradáveis são como um favo de mel, doçura para a alma e saúde para os ossos.',
    'pt-PT': 'Palavras agradáveis são como um favo de mel, doçura para a alma e saúde para os ossos.',
    en: 'Gracious words are like a honeycomb, sweetness to the soul and health to the bones.',
    es: 'Las palabras agradables son como panal de miel, dulzura para el alma y medicina para los huesos.',
    fr: "Les paroles gracieuses sont comme un rayon de miel, douceur pour l'âme et santé pour les os.",
    de: 'Freundliche Worte sind wie Honig, süß für die Seele und heilsam für die Knochen.',
    it: "Le parole gentili sono come un favo di miele, dolcezza per l'anima e salute per le ossa.",
    zh: '良言如同蜂房，使心感甘甜，使骨得医治。',
    ja: '優しい言葉は蜂蜜の巣のようであり、魂に甘さを与え、骨に健康をもたらします。',
    ko: '친절한 말은 꿀송이 같아서 영혼에 달고 뼈에 양약이 되느니라.',
    ar: 'الكلمات الطيبة مثل شهد العسل، حلاوة للنفس وشفاء للعظام.',
  },
  'Psalm 90:12': {
    pt: 'Ensina-nos a contar os nossos dias, para que alcancemos um coração sábio.',
    'pt-PT': 'Ensina-nos a contar os nossos dias, para que alcancemos um coração sábio.',
    en: 'Teach us to number our days, that we may gain a heart of wisdom.',
    es: 'Enséñanos a contar nuestros días, para que alcancemos corazón de sabiduría.',
    fr: 'Enseigne-nous à compter nos jours, afin que nous acquérions un cœur sage.',
    de: 'Lehre uns, unsere Tage zu zählen, damit wir ein kluges Herz erlangen.',
    it: 'Insegnaci a contare i nostri giorni, perché acquistiamo un cuore saggio.',
    zh: '求你指教我们怎样数算自己的日子，好叫我们得着智慧的心。',
    ja: '私たちに日数を数えることを教えてください。知恵の心を得るために。',
    ko: '우리에게 우리 날 계수함을 가르치사 지혜로운 마음을 얻게 하소서.',
    ar: 'علمنا أن نحسب أيامنا لكي نأتي بقلب حكيم.',
  },
  'James 1:17': {
    pt: 'Toda boa dádiva e todo dom perfeito vêm do alto, descendo do Pai das luzes.',
    'pt-PT': 'Toda a boa dádiva e todo o dom perfeito vêm do alto, descendo do Pai das luzes.',
    en: 'Every good gift and every perfect gift is from above, coming down from the Father of lights.',
    es: 'Toda dádiva buena y todo don perfecto desciende de lo alto, del Padre de las luces.',
    fr: "Tout don excellent et tout don parfait vient d'en haut, du Père des lumières.",
    de: 'Jede gute Gabe und jedes vollkommene Geschenk kommt von oben, vom Vater der Lichter.',
    it: "Ogni buon dono e ogni dono perfetto viene dall'alto, dal Padre delle luci.",
    zh: '各样美善的恩赐和各样完美的礼物都是从上头来的，从光父那里降下来的。',
    ja: 'すべての良い贈り物と完全な贈り物は上から来ており、光の父から降りてきます。',
    ko: '온갖 좋은 은사와 온전한 선물이 다 위로부터 내려온다 곧 빛들의 아버지에게서라.',
    ar: 'كل عطية صالحة وكل موهبة كاملة تنزل من فوق من عند أبي الأنوار.',
  },
  'Galatians 6:9': {
    pt: 'Não nos cansemos de fazer o bem, porque a seu tempo colheremos, se não desistirmos.',
    'pt-PT': 'Não nos cansemos de fazer o bem, porque a seu tempo colheremos, se não desistirmos.',
    en: 'And let us not grow weary of doing good, for in due season we will reap, if we do not give up.',
    es: 'No nos cansemos de hacer bien, porque a su debido tiempo segaremos, si no desfallecemos.',
    fr: 'Ne nous lassons pas de faire le bien, car nous moissonnerons au temps voulu, si nous ne perdons pas courage.',
    de: 'Und lassen Sie uns nicht müde werden, Gutes zu tun, denn zur rechten Zeit werden wir ernten, wenn wir nicht aufgeben.',
    it: 'Non stanchiamoci di fare il bene, perché a suo tempo raccoglieremo, se non perdiamo il coraggio.',
    zh: '我们行善不可丧志，因为若不灰心，到了时候就要收成。',
    ja: '善い行いをすることに疲れてはいけません。なぜなら、諦めなければ、やがて刈り取ることができるからです。',
    ko: '우리가 선을 행하되 낙심하지 말지니 포기하지 아니하면 때가 이르매 거두리라.',
    ar: 'ولا نملّ من فعل الخير لأننا سنحصد في وقته إن لم نكل.',
  },
  '1 Corinthians 13:4-5': {
    pt: 'O amor é paciente, o amor é bondoso. Não inveja, não se vangloria, não se ensoberbece. Não é mal-educado, não procura os seus próprios interesses.',
    'pt-PT': 'O amor é paciente, o amor é bondoso. Não inveja, não se vangloria, não se ensoberbece. Não é mal-educado, não procura os seus próprios interesses.',
    en: 'Love is patient and kind; love does not envy or boast; it is not arrogant or rude. It does not insist on its own way.',
    es: 'El amor es paciente, es benigno; el amor no tiene envidia, no es jactancioso, no se envanece. No es indecoroso, no busca lo suyo.',
    fr: "L'amour est patient, l'amour est bienveillant; l'amour n'est pas envieux ni vantard; il n'est pas arrogant ou impoli. Il n'insiste pas sur ses propres droits.",
    de: 'Die Liebe ist geduldig, die Liebe ist freundlich; die Liebe beneidet nicht, prahlt nicht, ist nicht hochmütig. Sie ist nicht unanständig, besteht nicht auf ihrem Recht.',
    it: "L'amore è paziente e gentile; l'amore non invidia né si vanta; non è arrogante né scortese. Non insiste sul suo diritto.",
    zh: '爱是恒久忍耐，又有恩慈；爱是不嫉妒，爱是不自夸，不张狂，不做害羞的事，不求自己的益处。',
    ja: '愛は忍耐強く、親切です。愛は嫉妬したり、自慢したりしません。高慢ではなく、無礼でもありません。自分の利益を求めません。',
    ko: '사랑은 오래 참고 온유하며 사랑은 시기하지 아니하며 자랑하지 아니하며 교만하지 아니하며 무례히 행하지 아니하며 자기의 유익을 구하지 아니하며.',
    ar: 'الحب صبور متسامح، الحب لا يحسد ولا يتفاخر ولا يتكبر، لا يفعل شيئاً قبيحاً ولا يطلب ما لنفسه.',
  },
  '1 Thessalonians 5:11': {
    pt: 'Portanto, consolem-se e edifiquem-se mutuamente, como de fato estão fazendo.',
    'pt-PT': 'Portanto, consolem-se e edifiquem-se mutuamente, como de facto estão a fazer.',
    en: 'Therefore encourage one another and build each other up, just as in fact you are doing.',
    es: 'Por tanto, anímense y edifiquense mutuamente, tal como lo vienen haciendo.',
    fr: "C'est pourquoi encouragez-vous mutuellement et édifiez-vous les uns les autres, comme vous le faites.",
    de: 'Daher ermutigt einander und erbaut einander, wie ihr es auch tut.',
    it: 'Perciò incoraggiatevi a vicenda ed edificatevi gli uni gli altri, come infatti state facendo.',
    zh: '所以你们要互相劝慰，互相建立，正如你们素常所行的。',
    ja: 'したがって、互いに励まし合い、互いに高め合いなさい。事実、あなたがたはそうしているのです。',
    ko: '그러므로 피차 권면하고 서로 덕을 세우기를 너희가 하는 것 같이 하라.',
    ar: 'لذا شجعوا بعضكم البعض وابنوا بعضكم الآخر كما تفعلون فعلاً.',
  },
  'Hebrews 10:24-25': {
    pt: 'E consideremos como nos provocar mutuamente à caridade e às boas obras. Não deixemos de nos reunir, como é costume de alguns, mas exortemo-nos uns aos outros.',
    'pt-PT': 'E consideremos como nos provocar mutuamente à caridade e às boas obras. Não deixemos de nos reunir, como é costume de alguns, mas exortemo-nos uns aos outros.',
    en: 'Let us consider how we may spur one another on toward love and good deeds. Let us not give up meeting together, but let us encourage one another.',
    es: 'Consideremos cómo incitarnos mutuamente al amor y a las buenas obras. No dejemos de reunirnos, como algunos tienen por costumbre, sino animémonos los unos a los otros.',
    fr: "Pensons à la manière de nous exciter à l'amour et aux bonnes œuvres. N'abandonnons pas notre assemblée, comme quelques-uns en ont l'habitude, mais encourageons-nous.",
    de: 'Und denken wir darauf hin, uns zur Liebe und zu guten Werken zu reizen. Verlassen wir nicht die Versammlung, wie es einige gewohnt sind, sondern ermuntern wir uns.',
    it: 'E consideriamo come potremmo stimolarci a vicenda all\'amore e alle buone opere. Non cessiamo di riunirci, ma incoraggiamoci gli uni gli altri.',
    zh: '我们也要思想怎样彼此相劝，激发爱心，勉励行善。你们不可停止聚会，好像那些不聚会的人，倒要彼此劝勉。',
    ja: '互いに愛と善い行いを促すために、どのように考えるべきかを考えましょう。集会をやめないでください。むしろ、互いに励まし合いなさい。',
    ko: '서로 돌아보아 사랑과 선행을 격려하며 모이기를 폐하는 어떤 사람들의 습관과 같이 하지 말고 오직 권하여.',
    ar: 'ولننظر كيف ننشط بعضنا إلى المحبة والأعمال الحسنة، غير تاركين اجتماعنا كما اعتاد قوم بل مشجعين بعضنا بعضاً.',
  },
  'Proverbs 17:17': {
    pt: 'O amigo ama em todo o tempo e o irmão nasce para a hora da angústia.',
    'pt-PT': 'O amigo ama em todo o tempo e o irmão nasce para a hora da angústia.',
    en: 'A friend loves at all times, and a brother is born for a time of adversity.',
    es: 'En todo tiempo ama el amigo, y es como un hermano en tiempo de angustia.',
    fr: "Un ami aime en tout temps, et un frère est né pour l'adversité.",
    de: 'Ein Freund liebt zu aller Zeit, und ein Bruder wird für Not geboren.',
    it: "Un amico ama in ogni momento e un fratello nasce per il tempo dell'avversità.",
    zh: '朋友乃时常亲爱，弟兄为要同当患难。',
    ja: '友人はいつも愛し、兄弟は困難な時のために生まれています。',
    ko: '친구는 사랑이 항상 있고 형제는 위급한 때를 위하여 났느니라.',
    ar: 'الصديق يحب في كل وقت والأخ يولد لوقت الضيق.',
  },
  '1 Corinthians 13:13': {
    pt: 'Assim, permanecem agora estes três: a fé, a esperança e o amor. O maior deles, porém, é o amor.',
    'pt-PT': 'Assim, permanecem agora estes três: a fé, a esperança e o amor. O maior deles, porém, é o amor.',
    en: 'And now these three remain: faith, hope and love. But the greatest of these is love.',
    es: 'Ahora, pues, permanecen estas tres cosas: la fe, la esperanza y el amor. Pero la mayor de ellas es el amor.',
    fr: "Maintenant donc ces trois choses demeurent: la foi, l'espérance et l'amour; mais la plus grande, c'est l'amour.",
    de: 'Nun aber bleiben Glaube, Hoffnung, Liebe, diese drei; aber die Liebe ist die größte unter ihnen.',
    it: "Ora dunque rimangono queste tre cose: fede, speranza e amore; ma la più grande di esse è l'amore.",
    zh: '如今常存的有信，有望，有爱这三样，其中最大的是爱。',
    ja: 'こういうわけで、いつまでも残るのは信仰、希望、愛、この三つです。その中で最も優れているのは愛です。',
    ko: '그런즉 믿음 소망 사랑 이 세 가지는 항상 있을 것인데 그 중의 제일은 사랑이라.',
    ar: 'أما الآن فيثبت الإيمان والرجاء والمحبة، هذه الثلاثة، ولكن أعظمهن المحبة.',
  },
  'Romans 12:15': {
    pt: 'Alegrem-se com os que se alegram; chorem com os que choram.',
    'pt-PT': 'Alegrem-se com os que se alegram; chorem com os que choram.',
    en: 'Rejoice with those who rejoice; mourn with those who mourn.',
    es: 'Alégrense con los que están alegres; lloren con los que lloran.',
    fr: 'Réjouissez-vous avec ceux qui se réjouissent; pleurez avec ceux qui pleurent.',
    de: 'Freut euch mit den Fröhlichen und weint mit den Weinenden!',
    it: 'Rallegratevi con quelli che sono allegri; piangete con quelli che piangono.',
    zh: '与喜乐的人要同乐，与哀哭的人要同哭。',
    ja: '喜ぶ者と共に喜び、泣く者と共に泣きなさい。',
    ko: '즐거워하는 자들과 함께 즐거워하고 우는 자들과 함께 울라.',
    ar: 'فرحا مع الفرحين وبكاء مع الباكين.',
  },
  '1 John 3:18': {
    pt: 'Filhinhos, não amemos de palavra nem de língua, mas de fato e de verdade.',
    'pt-PT': 'Filhinhos, não amemos de palavra nem de língua, mas de facto e de verdade.',
    en: 'Dear children, let us not love with words or speech but with actions and in truth.',
    es: 'Hijitos míos, no amemos de palabra ni de lengua, sino de hecho y en verdad.',
    fr: "Petits enfants, n'aimons pas en paroles et avec la langue, mais en action et en vérité.",
    de: 'Liebe Kinder, lasst uns nicht mit Worten lieben, sondern in der Tat und in Wahrheit.',
    it: 'Figli miei, non amiamo a parole né con la lingua, ma in atto e in verità.',
    zh: '小子们哪，我们相爱，不要只在言语和舌头上，总要在行为和诚实上。',
    ja: '子どもたちよ。言葉や舌ではなく、行動と誠実で愛しましょう。',
    ko: '자녀들아 우리가 말과 혀로만 사랑하지 말고 행함과 진실함으로 하자.',
    ar: 'يا أطفالي، لا نحب بالكلام واللسان بل بالعمل والحقيقة.',
  },
  'Colossians 3:12': {
    pt: 'Portanto, como povo escolhido de Deus, santo e muito amado, revistam-se de compaixão, bondade, humildade, mansidão e paciência.',
    'pt-PT': 'Portanto, como povo escolhido de Deus, santo e muito amado, revistam-se de compaixão, bondade, humildade, mansidão e paciência.',
    en: "Therefore, as God's chosen people, holy and dearly loved, clothe yourselves with compassion, kindness, humility, gentleness and patience.",
    es: 'Por lo tanto, como escogidos de Dios, santos y amados, revístanse de compasión, bondad, humildad, mansedumbre y paciencia.',
    fr: "Ainsi donc, comme des élus de Dieu, saints et bien-aimés, revêtez-vous de sentiments de miséricorde, de bonté, d'humilité, de douceur et de patience.",
    de: 'Zieht also an, als Gottes Auserwählte, Heilige und Geliebte, Erbarmen, Güte, Demut, Sanftheit und Geduld an.',
    it: 'Rivestite dunque, come eletti di Dio, santi e amati, di sentimenti di compassione, di benevolenza, di umiltà, di mitezza, di pazienza.',
    zh: '所以，你们既是神所拣选的、所亲爱的圣洁子民，就要存怜悯、恩慈、谦虚、温柔、忍耐的心。',
    ja: 'ですから、神に選ばれた者、聖なる者、愛される者として、思いやり、親切、謙虚さ、温和、忍耐を身につけなさい。',
    ko: '그러므로 너희는 하나님의 택하신 거룩하고 사랑받는 자처럼 긍휼과 자비와 겸손과 온유와 오래 참음을 옷 입고.',
    ar: 'فالبسوا، كمختاري الله وقديسيه والمحبوبين، أحشاء الرحمة والإحسان والتواضع والوداعة والطول الأنات.',
  },
  'John 14:27': {
    pt: 'Deixo-vos a paz, a minha paz vos dou. Não vos dou como o mundo dá. Não se perturbe o vosso coração, nem tenha medo.',
    'pt-PT': 'Deixo-vos a paz, a minha paz vos dou. Não vos dou como o mundo dá. Não se perturbe o vosso coração, nem tenha medo.',
    en: 'Peace I leave with you; my peace I give you. I do not give to you as the world gives.',
    es: 'La paz os dejo, mi paz os doy; no os la doy como el mundo la da.',
    fr: "Je vous laisse la paix, je vous donne ma paix. Ce n'est pas comme le monde donne que je vous la donne.",
    de: 'Frieden hinterlasse ich euch, meinen Frieden gebe ich euch. Nicht wie die Welt gibt, gebe ich euch.',
    it: 'Vi lascio la pace, vi do la mia pace. Non vi la do come la dà il mondo.',
    zh: '我留下平安给你们，我将我的平安赐给你们。我所赐的不像世人所赐的。',
    ja: '平安をあなたがたに残します。わたしの平安を与えます。世が与えるようには与えません。',
    ko: '평안을 너희에게 끼치노니 곧 나의 평안을 너희에게 주노라 내가 너희에게 주는 것은 세상이 주는 것 같지 아니하니라.',
    ar: 'السلام أترك لكم، سلامي أعطيكم. ليس كما يعطي العالم أعطيكم أنا.',
  },
  '2 Corinthians 13:14': {
    pt: 'A graça do Senhor Jesus Cristo, o amor de Deus e a comunhão do Espírito Santo sejam com todos vocês.',
    'pt-PT': 'A graça do Senhor Jesus Cristo, o amor de Deus e a comunhão do Espírito Santo sejam com todos vocês.',
    en: 'May the grace of the Lord Jesus Christ, and the love of God, and the fellowship of the Holy Spirit be with you all.',
    es: 'Que la gracia del Señor Jesucristo, el amor de Dios y la comunión del Espíritu Santo sean con todos ustedes.',
    fr: 'Que la grâce du Seigneur Jésus-Christ, l\'amour de Dieu et la communion du Saint-Esprit soient avec vous tous!',
    de: 'Die Gnade des Herrn Jesus Christus und die Liebe Gottes und die Gemeinschaft des Heiligen Geistes sei mit euch allen!',
    it: "La grazia del Signore Gesù Cristo, l'amore di Dio e la comunione dello Spirito Santo siano con tutti voi.",
    zh: '愿主耶稣基督的恩惠、神的慈爱、圣灵的感动常与你们众人同在！',
    ja: '主イエス・キリストの恵み、神の愛、聖霊の交わりが、あなたがた一同と共にありますように。',
    ko: '주 예수 그리스도의 은혜와 하나님의 사랑과 성령의 교통하심이 너희 무리와 함께 있을지어다.',
    ar: 'نعمة ربنا يسوع المسيح ومحبة الله وشركة الروح القدس مع جميعكم.',
  },
};

export function getFallbackVerse(reference: string, locale: string): string | null {
  const verses = BIBLE_FALLBACK_QUOTES[reference];
  if (!verses) return null;

  let normalizedLocale = locale.split('-')[0];
  if (normalizedLocale === 'pt' && locale === 'pt-PT') {
    normalizedLocale = 'pt-PT';
  }

  const supportedLocales: Record<string, keyof typeof verses> = {
    pt: 'pt',
    'pt-PT': 'pt-PT',
    en: 'en',
    es: 'es',
    fr: 'fr',
    de: 'de',
    it: 'it',
    zh: 'zh',
    ja: 'ja',
    ko: 'ko',
    ar: 'ar',
  };

  const localeKey = supportedLocales[normalizedLocale] || 'en';
  return verses[localeKey] || null;
}
